import React from 'react';
import { Flex } from 'rebass';
import { SearchInput } from '../../../../components/Form';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { FilterBarProps } from '../../../../components/FilterBar/FilterBar';
import { rebassProps } from '../../../../theme/theme';
import ResetFiltersButton from '../../../../components/FilterBar/ResetFiltersButton';
import {
  PropertyType,
  PropertyTypePicker,
} from '../../../../components/WaterService/PropertyTypePicker';
import { GenericStatusPicker } from '../../../../components/GenericStatusPicker';
import { getStringSearchPlaceholder } from '../../../../helpers/search';
import { searchFields } from './WaterServices';

export type WaterServiceFilters = {
  status?: 'ACTIVE' | 'INACTIVE';
  type?: PropertyType[];
  stringSearch?: string | undefined;
};

export const defaultFilters: WaterServiceFilters = {
  status: 'ACTIVE',
  type: undefined,
  stringSearch: undefined,
};

type FilterBarWaterServicesProps = FilterBarProps<WaterServiceFilters>;

const FilterBarWaterServices: React.FC<FilterBarWaterServicesProps> = (
  props
) => {
  const { filters, setFilters, selectedId } = props;

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFilters((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <Flex variant="filterBar.container" {...(props as rebassProps)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(searchFields)}
          autoFocus={isBrowser && !selectedId}
          width={350}
          name="stringSearch"
          value={filters.stringSearch === undefined ? '' : filters.stringSearch}
          onChange={onChange}
        />
        <GenericStatusPicker
          value={filters.status}
          isClearable
          onChange={(value) => {
            setFilters({
              ...filters,
              status: value,
            });
          }}
        />
        <PropertyTypePicker
          isMulti={true}
          onChange={(value) => {
            setFilters({
              ...filters,
              type: value,
            });
          }}
          value={filters.type}
        />
      </Flex>
      <Flex variant="filterBar.right">
        <ResetFiltersButton setFilters={setFilters} />
      </Flex>
    </Flex>
  );
};

FilterBarWaterServices.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarWaterServices;
